Greenmile.Components.PasswordValidator = function (user, validateInput, confirmInput, sendButton, entity='Users') {

  this.rootEl = document.createElement('div');
  this.passwordPolicies = [];
  this.user = user || null;
  this.validateInput = validateInput || null;
  this.confirmInput = confirmInput || null;
  this.sendButton = sendButton || null;
  this.entity = entity;

  this.loadPasswordPolicies = mountValidationList => {
    const loggedUser = Monet?.Session?.User?.login;
    const isLoggedUser = loggedUser === this.user;

    const apiService = new Monet.Ajax();

    apiService.url = '/PasswordPolicy/ByOrgOrGroup';
    apiService.method = 'POST';

    if(!isLoggedUser) {
      this.getUserPasswordPolicyByOrgOrGroup(apiService, mountValidationList);
    } else {
      this.getLoggedUserPasswordPolicyByOrgOrGroup(apiService, mountValidationList);
    }
  };


  this.throwError = error => {
    const parsedError = JSON.parse(error.responseText).errorMessages;

    throw Monet.Form.Messages.getErrorMessageToBeDisplayed(parsedError);
  }

  this.getUserPasswordPolicyByOrgOrGroup = (apiService, mountValidationList) => {
    const {
      organization: organizationField,
      groups: groupsField
    } = App.Forms[this.entity].form.fields;

    const organization = organizationField.getValue().id;
    const groups = groupsField?.getValue();
    const groupIds = groups?.map(group => group.id) || [];

    apiService.data = {
      organization,
      group: groupIds
    }

    apiService.success = data => {
      this.passwordPolicies = data;
      mountValidationList();
    };
    apiService.error = error => {
      this.throwError(error);
    };
    apiService.send();
  }

  this.getLoggedUserPasswordPolicyByOrgOrGroup = (apiService, mountValidationList) => {
    const loggedUser = Monet?.Session?.User;
    const { id, groups: loggedUserGroups } = loggedUser;
    const newAjaxInstance = new Monet.Ajax();
    
    newAjaxInstance.url = '/Users/filter?criteria={"filters":["organization.id"]}';
    newAjaxInstance.method = 'POST';
    newAjaxInstance.data = {
      id
    }
    newAjaxInstance.success = response => {
      const organizationId = response[0]?.organization?.id;
      const loggedUserGroupIds = loggedUserGroups.map(group => group.id);
      
      if(!organizationId){
        apiService.data = {
          group: loggedUserGroupIds
        }
      } else {
        apiService.data = {
          organization: organizationId,
          group: loggedUserGroupIds
        }
      }

      apiService.success = passwordPolicies => {
        this.passwordPolicies = passwordPolicies;
        mountValidationList();
      };
      apiService.error = error => {
        this.throwError(error);
      };
      apiService.send();
    };
    newAjaxInstance.error = error => {
      this.throwError(error);
    };
    newAjaxInstance.send();
  }

  const keyupValidateInput = e =>{
    const len = this.passwordPolicies.length;
    if (!document.querySelector('.pass-check-invalid') && document.querySelector('.pass-check-neutral')) {
       document.querySelector('.pass-check-neutral').className = 'pass-check-invalid';
    }

    for (let i = 0; i < len; i++) {
      if (this.passwordPolicies[i].hintObject.classList.contains('hintValid')) {
          this.passwordPolicies[i].hintObject.classList.remove('hintValid');
      }

      if (new RegExp(this.passwordPolicies[i].rule).test(e.target.value)) {
          this.passwordPolicies[i].hintObject.classList.add('hintValid');
      }
    }
  };

  const keyupConfirmInput = e => {
      if((e.target.value === this.validateInput.value) &&
          (this.rootEl.querySelectorAll('.hintValid').length === this.passwordPolicies.length)){
          document.querySelector('.pass-check-invalid') ?
              document.querySelector('.pass-check-invalid').className = 'pass-check-valid' : "";
          e.target.classList.remove("invalidInput");
          this.sendButton.classList.add('allHintsValid');
          this.sendButton.disabled = false;
      } else if (this.sendButton.classList.contains('allHintsValid')){
          document.querySelector('.pass-check-valid') ?
              document.querySelector('.pass-check-valid').className = 'pass-check-invalid' : "";
          e.target.classList.add("invalidInput");
          this.sendButton.classList.remove('allHintsValid');
          this.sendButton.disabled = true;
      }
  };

  this.render = () => {
    this.rootEl = document.createElement('div');

    this.loadPasswordPolicies(() => {
        const passworPoliciesLength = this.passwordPolicies.length;
        const ul = document.createElement('ul');

        for (let i = 0; i < passworPoliciesLength; i++) {
            const li = document.createElement('li');

            li.appendChild(
                document.createTextNode(
                    Monet.I18n.getResourcesByKey(
                        this.passwordPolicies[i].resource,
                        this.passwordPolicies[i].rule.replace(/[^0-9]/g,'')
                    )
                )
            );

            this.passwordPolicies[i].hintObject = li;

            ul.appendChild(li);  
        }

        this.validateInput.addEventListener("keyup", keyupValidateInput);

        if (confirmInput) {
            this.confirmInput.addEventListener("keyup", keyupConfirmInput);
        }

        if(passworPoliciesLength) {
          this.rootEl.appendChild(ul);
        }
    });

    this.rootEl.className = 'passwordHints';
    return this.rootEl;
  };

  return this;
};
